import React from 'react';
import { BootstrapButton } from '../bootstrap-button/BootstrapButton';
export var StepperFooter = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, handleBack = _a.handleBack, handleNext = _a.handleNext, backButtonText = _a.backButtonText, nextButtonText = _a.nextButtonText, footer = _a.footer;
    if (footer) {
        return footer({ steps: steps, activeStep: activeStep, handleBack: handleBack, handleNext: handleNext });
    }
    return (React.createElement("div", { className: "d-flex justify-content-between mx-2" },
        React.createElement(BootstrapButton, { ariaLabel: "Back", disabled: activeStep === 0, onClick: handleBack, color: "default", className: "mr-2 back-button" }, backButtonText),
        React.createElement(BootstrapButton, { ariaLabel: "Next", color: steps[activeStep].nextButtonStyle || 'primary', onClick: handleNext }, nextButtonText)));
};
StepperFooter.defaultProps = {
    backButtonText: 'Go Back',
    nextButtonText: 'Next',
    completionButtonText: 'Back to Home',
};
export default StepperFooter;
//# sourceMappingURL=StepperFooter.js.map


// WEBPACK FOOTER //
// ../../../src/components/stepper/StepperFooter.tsx